function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.5583 2.24631C14.3224 2.98429 14.9318 3.86704 15.3511 4.84308C15.7704 5.81911 15.9911 6.86887 16.0003 7.9311C16.0095 8.99334 15.8071 10.0468 15.4049 11.0299C15.0026 12.0131 14.4086 12.9063 13.6575 13.6575C12.9063 14.4086 12.0131 15.0026 11.0299 15.4049C10.0468 15.8071 8.99333 16.0095 7.9311 16.0003C6.86886 15.9911 5.8191 15.7704 4.84307 15.3511C3.86704 14.9319 2.98428 14.3224 2.2463 13.5583C0.78904 12.0495 -0.0173144 10.0287 0.000913372 7.9311C0.0191402 5.83353 0.860492 3.82703 2.34376 2.34376C3.82702 0.860497 5.83352 0.019146 7.9311 0.00091959C10.0287 -0.0173078 12.0495 0.789047 13.5583 2.24631ZM3.37431 3.37431C2.17341 4.57521 1.49875 6.20398 1.49875 7.90231C1.49875 9.60064 2.17341 11.2294 3.37431 12.4303C4.57521 13.6312 6.20398 14.3059 7.9023 14.3059C9.60063 14.3059 11.2294 13.6312 12.4303 12.4303C13.6312 11.2294 14.3059 9.60064 14.3059 7.90231C14.3059 6.20398 13.6312 4.57521 12.4303 3.37431C11.2294 2.17341 9.60064 1.49875 7.90231 1.49875C6.20398 1.49875 4.57521 2.17341 3.37431 3.37431ZM8.70231 11.9023L7.1023 11.9023L7.10231 7.10231L8.70231 7.10231L8.70231 11.9023ZM8.70231 5.50231L7.10231 5.50231L7.10231 3.90231L8.70231 3.90231L8.70231 5.50231Z",
  fill: "#4B556F"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white",
  transform: "translate(16 16) rotate(-180)"
})));

var SvgExclamationOutline = function SvgExclamationOutline(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgExclamationOutline, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/exclamation-outline.98d35686.svg";
export { ForwardRef as ReactComponent };